export const titleCodes = {

    categories: {
        code: "${merchantId}_tmpl_title_1",
        title: "Shop by Categories"
    },

    mombabycare: {
        code: "${merchantId}_tmpl_title_3",
        title: "Mother & Baby Care"
    },

    reasons: {
        code: "${merchantId}_tmpl_title_4",
        title: "Reason why you must buy at Vcare Pharmacy"
    },

    multiVita: {
        code: "${merchantId}_tmpl_title_5",
        title: "Multivitamin and Minerals"
    },

    fame: {
        code: "${merchantId}_tmpl_title_6",
        title: "FAME Products"
    },

}

export const textCodes = {

    reason1: {
        code: "${merchantId}_tmpl_text_1",
        text: "The Faster Delivery in Yangon"
    },

    rs1: {
        code: "${merchantId}_tmpl_text_12",
        text: "အလျှင်မြန်ဆုံး ပို့ဆောင်မှု"
    },

    reason2: {
        code: "${merchantId}_tmpl_text_",
        text: "Wide Range of English Medicine and Myanmar medicine"
    },

    rs2: {
        code: "${merchantId}_tmpl_text_13",
        text: "မိသားစုအတွက် လိုအပ်သော အင်္ဂလိပ်ဆေး အမျိုးမျိုးနှင့် မြန်မာဆေးအမျိုးမျိုး"
    },

    reason3: {
        code: "${merchantId}_tmpl_text_3",
        text: "All types of Medicine can be bought at one place"
    },

    rs3: {
        code: "${merchantId}_tmpl_text_14",
        text: "မှန်ကန်သော ဆေးဝါးများကို တစ်နေရာတည်းတွင် တစ်ခါတည်း ဝယ်ယူရရှိနိုင်ခြင်း"
    },
}

export const imageCodes = {

    slider1: {
        code: "${merchantId}_tmpl_img_24",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fv%20ban.png?alt=media&token=d41e0de8-0f2e-409d-87e4-3caeefd22561"
    },

    slider2: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fv%20ban1.png?alt=media&token=9fd5cd3e-8168-4b16-9099-98288c72afbd"
    },

    cate1: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcategory.PNG?alt=media&token=eea8fb7e-1956-4111-b4fe-55e610a37b2b"
    },

    fame1: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffame1.jpg?alt=media&token=5731d869-1ce3-4354-ae38-da2ecbf8ce44"
    },

    fame2: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffame2.jpg?alt=media&token=a76c8c34-0cb1-4162-814b-34e82cf24a5a"
    },

    fame3: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffame3.jpg?alt=media&token=2b45ccbe-bb4b-40f1-9ef4-2dd9aedb434c"
    },

    fame4: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffame4.jpg?alt=media&token=3a432d02-864b-47e1-8c30-8e6fdcb7c41e"
    },

    fame5: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffame5.jpg?alt=media&token=347ec758-4800-4a01-a764-85bec09c7c4a"
    },

    fame6: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffame6.jpg?alt=media&token=f8038d83-bd7b-41d2-8152-da515e54f45e"
    },

    multi1: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmulti1.jpg?alt=media&token=18202c9c-5351-4fd8-abc0-f50dcc6591f4"
    },

    multi2: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmulti2.jpg?alt=media&token=51d3f14a-8dda-428c-89b8-a6bc11b6eea2"
    },

    multi3: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmulti3.jpg?alt=media&token=4d52a004-0bb3-45a8-bf0a-688dd31a8399"
    },

    multi4: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmulti4.jpg?alt=media&token=f91f5c8a-5b47-4ca4-8b46-85e882a1a50f"
    },

    multi5: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmulti5.jpg?alt=media&token=ce62ff3f-c978-48d7-bed7-2d24ce52dfbc"
    },

    multi6: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmulti6.jpg?alt=media&token=c6de35ed-7c1f-486f-b14f-bfb69bf1c2f8"
    },

    momb1: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fviber_image_2022-09-02_16-18-56-585.png?alt=media&token=6a395db8-87bf-456e-af48-2b14216465a8"
    },

    momb2: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fviber_image_2022-09-04_20-19-55-016.png?alt=media&token=584a8633-2cf4-47a0-a380-13bd8fd2dd7f"
    },

    momb3: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fviber_image_2022-09-04_20-39-27-063.png?alt=media&token=0013c09f-6151-4ad1-971a-794be08ab204"
    },

    momb4: {
        code: "${merchantId}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fviber_image_2022-09-02_16-32-31-524.png?alt=media&token=86cccce2-5e94-4884-8f3c-135cf7c0ceff"
    },

    choose: {
        code: "${merchantId}_tmpl_img_26",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fslide3.jpg?alt=media&token=136ca59a-6088-4140-b8b0-0bb9c0c8f135"
    },
}